import { CallToActionSplit } from "../../../../modules/content/components/CallToActionSplit/CallToActionSplit";
import { CallToActionStacked } from "../../../../modules/content/components/CallToActionStacked/CallToActionStacked";
import { AbyssSection } from "../../../../modules/content/components/AbyssSection/AbyssSection";
import type { ICallToActionBlockProps } from "./CallToActionBlock.props";

export const CallToActionBlock = (props: ICallToActionBlockProps) => {
  const { anchorId, buttons, description, eyebrow, heading, image, parentClass, spacing, variant } =
    props;
  if (!eyebrow && !heading && !description && !buttons?.length && !image) return null;

  return (
    <AbyssSection className={parentClass} id={anchorId} spacing={spacing}>
      <div
        className="abyss-instrument-frame overflow-hidden rounded-xl border border-iron bg-obsidian p-7 text-frost shadow-[0_24px_80px_rgba(0,0,0,0.26)] md:p-12 lg:p-16"
        data-calibrated="true"
      >
        {variant === "split" ? (
          <CallToActionSplit {...props} />
        ) : (
          <CallToActionStacked {...props} />
        )}
      </div>
    </AbyssSection>
  );
};

CallToActionBlock.displayName = "Block::CallToActionBlock";
